import { Component, OnInit, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { ParameterService } from '../../../services/parameter.service';
import { AlertService } from '../../../services/alert.service';
import { KeyValuePair } from '../../../models/common/keyValuePair';
import { PARAMS } from '../../../contants/PARAMS';
import { EXPENSE_TYPES } from '../../../contants/EXPENSE_TYPES';

@Component({
  selector: 'ztsi-expense-type-picker',
  templateUrl: './ztsi-expense-type-picker.component.html',
  styleUrls: ['./ztsi-expense-type-picker.component.css'],
  providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ZtsiExpenseTypeComponent),
			multi: true
		}
	]
})
export class ZtsiExpenseTypeComponent implements ControlValueAccessor {
	types: string[] = EXPENSE_TYPES;

	@Input('value') _value: string;
	@Input() isDisabled: boolean = false;

	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.onChange(val);
		this.onTouched();
	}

	constructor(
		private _parameterService: ParameterService,
		private _alertService: AlertService
	) { }

	writeValue(value): void {
		if (value !== undefined) {
			this._value = value;
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	ngOnInit() {
		this._parameterService.getCachedSystemParameterArray<string>(PARAMS.EXPENSE_TYPES, 3600).subscribe(response => {
			if (response.length != undefined && response.length > 0) {
				this.types = response;
				this.types.sort();
			}
			else {
				console.log('Unable to load expense type selection.');
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-expense-type-picker/ztsi-expense-type-picker.component.ts